const ingredientsList = [{
        id: 1,
        img: "./images/Aile.png",
        name: "Aile",
        rating: 37,
        rarity: "uncommun",
    },
    {
        id: 2,
        img: "./images/Banane.png",
        name: "Banane",
        rating: 85,
        rarity: "commun",
    },
    {
        id: 3,
        img: "./images/Courgette.png",
        name: "Courgette",
        rating: 74,
        rarity: "commun",
    },
    {
        id: 4,
        img: "./images/Dent.png",
        name: "Dent",
        rating: 36,
        rarity: "uncommun",
    },
    {
        id: 5,
        img: "./images/Ananas.png",
        name: "Ananas",
        rating: 77,
        rarity: "commun",
    },
    {
        id: 6,
        img: "./images/Dragon.png",
        name: "Dragon",
        rating: 3,
        rarity: "rare",
    },
    {
        id: 7,
        img: "./images/Escargot.png",
        name: "Escargot",
        rating: 64,
        rarity: "commun",
    },
    {
        id: 8,
        img: "./images/Fleur-1.png",
        name: "Fleur-1",
        rating: 27,
        rarity: "uncommun",
    },
    {
        id: 9,
        img: "./images/Fleur-2.png ",
        name: "Fleur-2",
        rating: 23,
        rarity: "uncommun",
    },
    {
        id: 10,
        img: "./images/Glace.png",
        name: "Glace",
        rating: 66,
        rarity: "commun",
    },
    {
        id: 11,
        img: "./images/Livre.png",
        name: "Livre",
        rating: 17,
        rarity: "rare",
    },
    {
        id: 12,
        img: "./images/Patate.png",
        name: "Patate",
        rating: 88,
        rarity: "commun",
    },
    {
        id: 13,
        img: "./images/Poisson.png",
        name: "Poisson",
        rating: 80,
        rarity: "commun",
    },
    {
        id: 14,
        img: "./images/Poivron.png",
        name: "Poivron",
        rating: 55,
        rarity: "commun",
    },
    {
        id: 15,
        img: "./images/Potion-1.png",
        name: "Potion-1",
        rating: 18,
        rarity: "rare",
    },
    {
        id: 16,
        img: "./images/Potion-2.png",
        name: "Potion-2",
        rating: 15,
        rarity: "rare",
    },
    {
        id: 17,
        img: "./images/Potion-3.png",
        name: "Potion-3",
        rating: 44,
        rarity: "uncommun",
    },
    {
        id: 18,
        img: "./images/Tomate.png",
        name: "Tomate",
        rating: 99,
        rarity: "commun",
    },
    {
        id: 19,
        img: "./images/Viande-1.png",
        name: "Viande-1",
        rating: 40,
        rarity: "uncommun",
    },
    {
        id: 20,
        img: "./images/Viande-2.png",
        name: "Viande-2",
        rating: 35,
        rarity: "uncommun",
    }
];
export default ingredientsList;